import { Component, OnInit, inject, signal } from "@angular/core";
import { CertDNSFirewallTableComponent } from "../../../../components/cert/cert-dns-firewall-table/cert-dns-firewall-table";
import { PageInfo, SearchFilter } from "../../../../gql/generated";
import { Sort } from "@angular/material/sort";
import { DNS_FIREWALL_QUERY } from "../../../../graphql/domain/dns-firewall";
import { Apollo } from "apollo-angular";

@Component({
  selector: "dns-firewall-tab",
  templateUrl: "dns-firewall-tab.html",
  imports: [CertDNSFirewallTableComponent],
})
export class DnsFirewallTabComponent implements OnInit {
  private apollo = inject(Apollo);

  protected dnsFirewallLogs = signal<any[]>([]);
  protected searchFilter = signal<SearchFilter>({});
  protected pageInfo = signal<PageInfo>(undefined);
  protected prefixes = signal<string[]>([]);

  private paginationAfter = 0;
  private sortInfo: Sort;
  private accessCustomerId: string;

  ngOnInit() {
    this.accessCustomerId = localStorage.getItem("viewingCustomerGUID");
    this.fetchDnsFirewallInformation();
  }

  async fetchDnsFirewallInformation() {
    this.apollo
      .query<any>({
        query: DNS_FIREWALL_QUERY,
        variables: {
          filter: this.buildFilter(),
          first: 20,
          after: this.paginationAfter,
          sort: this.buildSort(),
        },
      })
      .subscribe(({ data }) => {
        this.dnsFirewallLogs.set(data.dnsFirewallLogs || []);

        // Update total items in pageInfo +1 to account for the first item
        // and for the `{{ "Pagination.of" | translate }} {{ pageInfo?.totalItems - 1 }}` in pagination.html
        this.pageInfo.set({
          ...data.dnsFirewallLogs.pageInfo,
          totalItems: data.dnsFirewallLogs.pageInfo.totalItems + 1,
        });
      });
  }

  onFiltersChanged(event: any) {
    this.searchFilter.set(event);
    this.fetchDnsFirewallInformation();
  }

  onPaginationChanged(event: number) {
    this.paginationAfter = event > -1 ? event : 0;
    this.fetchDnsFirewallInformation();
  }

  onSortingChanged(event: any) {
    this.sortInfo = event;
    this.fetchDnsFirewallInformation();
  }

  buildFilter() {
    const filter: SearchFilter = {
      customerId: this.accessCustomerId,
    };
    return {
      ...this.searchFilter(),
      ...filter,
    };
  }

  buildSort() {
    return {
      order: [{ [this.sortInfo?.active || "recordedAt"]: this.sortInfo?.direction?.toUpperCase() || "DESC" }],
    };
  }
}
